import { BrandMark } from '@/components/BrandMark';

export function Footer() {
  return (
    <footer className="border-t border-white/8 bg-[color:var(--nq-bg-deep)] py-14">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <BrandMark wordmarkSize={20} />
          <span className="mkt-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            Democratize Wealth Management
          </span>
        </div>

        <div className="h-px w-full bg-white/8" />

        <p className="max-w-3xl text-sm leading-relaxed text-muted-foreground">
          NovaQuantis is a planned AI-driven investment strategy delivered through a
          regulated ETF wrapper. This website is for informational purposes only and
          does not constitute investment, legal, or tax advice, or an offer or
          solicitation to buy or sell any security. It is not a prospectus.
        </p>
        <p className="max-w-3xl text-sm leading-relaxed text-muted-foreground">
          Investing involves risk, including possible loss of principal. Any offer of
          the fund will be made only by means of a prospectus and the required
          regulatory documents. Past performance does not guarantee future results.
        </p>
        <p className="mkt-mono text-[10px] uppercase tracking-[0.18em] text-white/30">
          © 2026 NovaQuantis · All rights reserved
        </p>
      </div>
    </footer>
  );
}
